const user_host = process.env.REACT_APP_USER_HOST;
const host = process.env.REACT_APP_API_HOST;


export const authDomain = `https://${process.env.REACT_APP_AUTH0_DOMAIN}`;

export const getApprovedBlogByDate = host + '/blog/approved?date='
export const getRejectedNewsByDate = host + '/blog/rejected?date='
export const getAllBlogs = host + '/blog/get/all'
export const getPendingNews = host + '/blog/pending'
export const createMobileNews = host + '/blog'
export const resaveMobileNews = host + '/blog/reSave'
export const getS3PresignedUrl = host + '/blog/presigned-url'
export const getAllCategories = host + '/category/all'
export const getSubCategoriesByCatId = host + '/subcat'
export const currentTopNews = host + '/top/current'
export const saveCustomizedTopNews = host + '/top/add'
export const findNewsById = host + '/blog/get'
export const getCurrentFeaturedNews = host + "/top/feature/current"
export const createCurrentFeaturedNews = host + "/top/feature/create";
export const filterBlogByCategoty = host + '/blog/filter'



export const getUserCount = host + "/admin/user/count";
export const refreshToken = host + "/admin/user/refresh";
export const logUser = host + "/admin/user/login";
export const getAllUsers = host + "/admin/getUsers";
export const updateUser = host + "/admin/user/update";
export const deleteUser = host + "/admin/user";
export const updateUserStatus = host + "/admin/user";
export const createAuth0User = host + "/admin/user/register";
export const getUserRolesAndPermissions = host + "/admin/rolesAndPermissions";
export const getAllUserRoles = host + "/dashboard/getAllUserRoles";


export const getAllInboxUnseenChats = user_host + "/question/admin/get/chats";
export const getAllSentChats = user_host + "/question/admin/get/chats/sent";
export const getSelectedChat = user_host + "/question/get/admin/chat/selected";
export const addnewAnswerForChat = user_host + "/question/create/answer";
export const assignSelectedChat = user_host + "/question/admin/assign/chat/selected";
export const checkAvailabilityToAssignSelectedChat = user_host + "/question/admin/assign/availability/chat/selected";
export const unassignSelectedChat = user_host + "/question/admin/unassigned/chat/selected";
export const getAskDoctorCategories = user_host + "/question/get/categories";
export const endChat = user_host + "/question/admin/end/chat/selected/";
export const endInboxChat = user_host + "/question/admin/end/inbox/selected/";
export const createEndChatReasonUrl = user_host + "/question/admin/endChat/reason/create/";

export const getCommunityPostsApi = user_host + "/community/post/get/admin";
export const getCommunityPostsByCatApi = user_host + "/community/post/getc/admin";
export const exportCommunityPostsDataApi = user_host + "/community/post/export/admin";
export const createCommunityPostComment = user_host + "/community/post/comments/create/verified";
export const createCommunityPostCommentReply = user_host + "/community/post/comments/replies/create/verified";
export const getSingleCommunityPost = user_host + "/community/post/get/admin";
export const getCommunityPostsFilter = user_host + "/community/post/get/filter";
export const getCommunityPostsCategories = user_host + "/community/post/category/get/all";
export const updateCommunityPostsIncrementViews = user_host + "/community/post/views/update";
export const changeCommunityPostCommentStatus = user_host + "/community/post/comments/change/status";
export const changeCommunityPostCommentReplyStatus = user_host + "/community/post/comments/replies/change/status";
export const getCommunityPostsCommentsReplies = user_host + "/community/post/comments/replies/get/admin/all";
export const changeCommunityPostStatus = user_host + "/community/post/change/status";
export const createFilterWord = user_host + "/community/filters/create";
export const getAllFilterWords = user_host + "/community/filters/get/all";
export const changeFilterWordsStatus = user_host + "/community/filters/change/status";
export const changeFilterWordsApproval = user_host + "/community/filters/change/approval";
export const getAllPostsToApprove = user_host + "/community/post/get/posts/approve";
export const getAllPostsCommentToApprove = user_host + "/community/post/get/approve/comments";
export const approveInAprrovePost = user_host + "/community/post/create/unauthorized/approve";
export const rejectInAprrovePost = user_host + "/community/post/create/unauthorized/reject";
export const changeUserBlacklistStatus = user_host + "/user/change/user/blacklist";
export const getAllBlacklistedUsers = user_host + "/user/get/all/blacklist";
export const getAllCommentsToApproveByPost = user_host + "/community/post/comments/get/admin/to-approve";
export const rejectToApproveComment = user_host + "/community/post/comments/remove/admin/to-approve";
export const approveToApproveCommentApi = user_host + "/community/post/comments/approve/admin/to-approve";

export const getCommunityPostsWithUserInteractions = user_host + "/community/post/comments/get/withReactions";
export const getCommunityPostComments = user_host + "/community/post/comments/get/admin";
export const getCommunityPostsByUser = user_host + "/community/post/comments/get/user";
export const getCommunityPostsCommentsRepliesWithUserInteractions = user_host + "/community/post/comments/replies/get/withReactions";
export const addCommunityPostCommentReaction = user_host + "/community/post/comments/heart/update";
export const addCommunityPostCommentReplyReaction = user_host + "/community/post/comments/replies/heart/update";
export const createCommunityPostCategory = user_host + "/community/post/category/create/admin";
export const changeCommunityPostCategoryStatus = user_host + "/community/post/category/change/admin";
export const getAllDoctors = host + "/admin/getAllDocs";


export const getBlogsDataChart = host + "/charts/blogsCount";
export const getRegisiteredUserDataChart = host + "/charts/regUsers";
export const getFLowWiseDataChart = host + "/charts/fwd";
export const getChatWiseDataChart = host + "/charts/cwd";
export const getLast7DaysDoctorChatWiseDataChart = host + "/charts/dcd";
export const getLast30DaysDoctorChatWiseDataChart = host + "/charts/dcd30";
export const getLast60DaysDoctorChatWiseDataChart = host + "/charts/dcd60";
export const getCompleteChatReport = host + "/charts/ccrp";
export const getCommunityReport = host + "/charts/drorcp";
export const getFeedbackReport = host + "/charts/feedbackReport";

export const sendMedicationNotif = host + "/notif/sendMedication";
export const sendInsightNotifications = host + "/notif/sendInsight";
export const sendDirectNotif = host + "/notif/sendDirect";
export const sendTopicNotif = host + "/notif/sendTopic";
export const getAdminLogs = host + "/admin/logs/all";

export const TOKEN = process.env.REACT_APP_API_TOKEN;

export const getAdminBannersList = host + "/banners/admin/list";
export const createAdminBanner = host + "/banners/admin/create";
export const updateAdminBannerStatus = (id) => host + `/banners/admin/${id}/status`;
export const deleteAdminBanner = (id) => host + `/banners/admin/${id}`;
export const toggleChatUrgency = user_host + "/question/admin/toggle-urgent";
export const reportRecipientsApi = host + "/admin/reports/recipients";
